export default __webpack_public_path__ + "static/media/letsikringvedsygdom.bbd35cc8.jpg";